import { isAndroid } from 'src/utils/isAndroid';
import { isIos } from 'src/utils/isIos';

export const PICK_IMAGE_OR_PDF = 'pickImageOrPdf';

export function createClickHandlerForImageOrPdfUpload(global = window): (e: MouseEvent) => void {
  if (isAndroid(global)) {
    return (e) => {
      e.preventDefault();
      global.imageOrPdfHandler.postMessage(PICK_IMAGE_OR_PDF);
      return;
    }
  }
  if (isIos(global)) {
    return (e) => {
      e.preventDefault();
      global.webkit.messageHandlers.imageOrPdfHandler.postMessage(PICK_IMAGE_OR_PDF);
      return;
    }
  }
  return () => {
    return;
  }
}
